module.exports = __webpack_public_path__ + "img/an_incomplete_building.94af2d41.svg";